import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-627e9840"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xag-container" }
const _hoisted_2 = {
  ref: "box",
  class: "map-box"
}
const _hoisted_3 = { class: "filter-box xag-flex-vertical" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "xag-flex",
  style: {"height":"100%","align-items":"center"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/general_icon_search_24.svg",
    style: {"height":"18px"}
  })
], -1))
const _hoisted_5 = {
  key: 1,
  class: "xag-page__footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_device_footer = _resolveComponent("device-footer")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, {
      title: "选择维修网点",
      rightTxt: "确定",
      rightCanClick: _ctx.rightCanClick,
      onRightClick: _ctx.onRightClick
    }, null, 8, ["rightCanClick", "onRightClick"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, null, 512)
    ]),
    _createElementVNode("div", {
      class: "xag-page__footer",
      style: _normalizeStyle({ height: `calc(${_ctx.pHeight} - 12px)` })
    }, null, 4),
    _createVNode(_component_van_popup, {
      class: "network-point-popup",
      show: _ctx.show,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.show) = $event)),
      closeable: false,
      round: "",
      position: "bottom",
      "safe-area-inset-bottom": "",
      overlay: false,
      style: _normalizeStyle({ height: _ctx.pHeight })
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_search, {
            modelValue: _ctx.keywords,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keywords) = $event)),
            modelModifiers: { trim: true },
            placeholder: "输入关键词"
          }, {
            "left-icon": _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.isMiniProgram)
            ? (_openBlock(), _createBlock(_component_device_footer, {
                key: 0,
                title: "确定",
                isCanClick: _ctx.rightCanClick,
                onFooterSubmit: _ctx.onRightClick
              }, null, 8, ["isCanClick", "onFooterSubmit"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5))
        ])
      ]),
      _: 1
    }, 8, ["show", "style"])
  ], 64))
}